export default __webpack_public_path__ + "static/media/celebration.9641a012.svg";